import { render } from "./appPaperCenter.vue?vue&type=template&id=c6a47518&scoped=true"
import script from "./appPaperCenter.vue?vue&type=script&lang=js"
export * from "./appPaperCenter.vue?vue&type=script&lang=js"

import "./appPaperCenter.vue?vue&type=style&index=0&id=c6a47518&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6a47518"]])

export default __exports__